import React, { Component } from "react";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import { fetchPost } from "../actions/viewPost.actions";
import Post from "../components/Post";
import {
    determineCorrectionAction,
    newCorrection,
    submitComment,
    toggleCorrectionReaction
} from "../actions/correction.actions";
import { push } from "react-router-redux";
import LoadingError from "../components/LoadingError";
import CorrectionPostDialogs from "./CorrectionPostDialogs";
import { CircularProgress } from "material-ui";
import {
    determinePostAction,
    togglePostReaction
} from "../actions/post.actions";

const styleSheet = theme => {
    return {
        mainContainer: {
            maxWidth: 600,
            padding: 0,
            width: "100%",
            margin: `${theme.spacing.unit * 2}px auto`
        },
        postContainer: {
            margin: "0"
        },
        "@media (min-width: 600px)": {
            mainContainer: {
                margin: `${theme.spacing.unit * 4}px auto`
            },
            postContainer: {
                margin: `0 ${theme.spacing.unit * 4}px`
            }
        },
        loadingContainer: {
            width: "100%",
            textAlign: "center"
        },
        progress: {
            margin: `0 ${theme.spacing.unit * 2}px`
        }
    };
};

function getPostId(props) {
    return props.match.params.postId;
}

function getCorrectionId(props) {
    const matches = (props.location.hash || "")
        .match(/correction=([a-z0-9A-Z]+)/);
    if (matches && matches.length === 2) {
        return matches[1];
    }
}

class ViewPostPage extends Component {
    static propTypes = {
        post: PropTypes.object.isRequired,
        requestPost: PropTypes.object.isRequired,
        currentUser: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired
    };

    initPage(id) {
        this.props.dispatch(fetchPost({ id }));
    }

    componentWillMount() {
        const pid = getPostId(this.props);
        this.initPage(pid);
    }

    componentWillReceiveProps(nextProps) {
        const pid = getPostId(this.props);
        const nextPID = getPostId(nextProps);
        if (pid !== nextPID) {
            this.initPage(nextPID);
        }
    }

    onCorrectionButtonClick = () => {
        const { post, dispatch } = this.props;
        dispatch(newCorrection({ post }));
    };

    gotoFeed = () => {
        this.props.dispatch(push("/feed"));
    };

    onCorrectionMenuItemClick = ({ correction, action }) => {
        this.props.dispatch(determineCorrectionAction(action)({ correction }));
    };

    renderContents() {
        const { t, post, requestPost, classes, currentUser } = this.props;
        if (requestPost.errors.count() > 0) {
            return (
                <LoadingError
                    message={t(
                        "viewPostPage.Something went wrong fetching the post"
                    )}
                    onRetry={this.gotoFeed}
                    retryText={t("viewPostPage.Back to feed")}
                />
            );
        } else if (requestPost.requesting) {
            return (
                <div className={classes.loadingContainer}>
                    <CircularProgress className={classes.progress} />
                </div>
            );
        }
        return (
            <div className={classes.postContainer}>
                <Post
                    defaultShowCorrectionId={getCorrectionId(this.props)}
                    onCorrectionReactionButtonClick={
                        this.onCorrectionReactionButtonClick
                    }
                    onCorrectionMenuItemClick={this.onCorrectionMenuItemClick}
                    onSubmitComment={this.onSubmitComment}
                    onReactionButtonClick={this.onReactionButtonClick}
                    onMenuClick={this.onPostMenuClick}
                    currentUser={currentUser}
                    post={post}
                    onCorrectionButtonClick={this.onCorrectionButtonClick}
                />
            </div>
        );
    }

    onPostMenuClick = ({ post, action }) => {
        this.props.dispatch(determinePostAction(action)({ post }));
    };

    onSubmitComment = payload => {
        this.props.dispatch(submitComment(payload));
    };

    onCorrectionReactionButtonClick = payload => {
        this.props.dispatch(toggleCorrectionReaction(payload));
    };

    onReactionButtonClick = payload => {
        this.props.dispatch(togglePostReaction(payload));
    };

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.mainContainer}>
                {this.renderContents()}
                <CorrectionPostDialogs />
            </div>
        );
    }
}

function mapStateToProps({ viewPost: { post, requestPost }, userSettings }) {
    return {
        post,
        requestPost,
        currentUser: userSettings
    };
}

export default wrapComponent(ViewPostPage, styleSheet, mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/ViewPostPage.jsx